import type { RateLikelihood } from '@tempmee/react';

/**
 * Maps a posted rate to the DS `RateSelection` "likelihood to fill" variant,
 * relative to the office's recommended (regional average) rate. Thresholds mirror
 * the legacy rate-status copy: >=106% is `more`, >=100% is `likely`, >=85% is
 * `less`, and anything lower is `unlikely`. A missing/zero average never penalizes.
 *
 * The label, icon and color are owned by the DS `RateSelection`; this function
 * only decides which likelihood variant a given rate maps to (domain logic).
 */
export const getRateLikelihood = (rate: number, averageRate: number): RateLikelihood => {
  const percentage = averageRate > 0 ? (rate / averageRate) * 100 : 100;

  if (percentage >= 106) return 'more';
  if (percentage >= 100) return 'likely';
  if (percentage >= 85) return 'less';
  return 'unlikely';
};
